import React from "react";
import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";

export default class Modal extends React.Component {
  constructor(props) {
    super(props);
    this._handleClose = this._handleClose.bind(this);
  }

  render() {
    const { photos, index } = this.props;

    // モーダルが閉じている場合はスライドをレンダリングしない
    if (index === null) {
      return null;
    }

    return (
      <div id="photo_detail" className="photo-modal">
        <a className="photo-modal__close" href="#" onClick={this._handleClose}>
          ×
        </a>
        <Swiper
          key={index}
          className={"photo-modal__swiper"}
          modules={[Navigation]}
          navigation={{
            prevEl: "#prev",
            nextEl: "#next",
          }}
          initialSlide={index}
          slidesPerView={1}
          loop={photos.length > 1}
        >
          {photos.map((photo) => (
            <SwiperSlide key={photo.id}>
              <div className="photo-modal__slide">
                <div className="photo-modal__detail">
                  {this._renderPhoto(photo)}
                  {this._renderCaption(photo)}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <ul id="navigation">
          <li id="prev" className="left photo-modal__arrow-left">
            <a href="#">
              <span className="sr-only">前の画像へ</span>
            </a>
          </li>
          <li id="next" className="right photo-modal__arrow-right">
            <a href="#">
              <span className="sr-only">次の画像へ</span>
            </a>
          </li>
        </ul>
      </div>
    );
  }

  _renderPhoto(photo) {
    if (this.props.index != null && photo.url.large) {
      return (
        <div className="swipeable photo-modal__img">
          <img
            src={photo.url.large}
            id="photo_detail_image"
            alt=""
            loading="lazy"
          />
        </div>
      );
    }
    return null;
  }

  _renderCaption(photo) {
    if (this.props.index != null && photo.caption) {
      return <p className="swipeable photo-modal__caption">{photo.caption}</p>;
    }
    return null;
  }

  // 一覧へ戻る
  _handleClose(e) {
    e.preventDefault();

    this.props.clickClose();
  }
}

Modal.propTypes = {
  photos: PropTypes.array.isRequired,
  index: PropTypes.number,
  total: PropTypes.number,
  clickClose: PropTypes.func.isRequired,
};
